import { gql } from '@apollo/client';

export const PayrollExpenseFragment = gql`
  fragment PayrollExpense on PayrollExpense {
    id
    amountCents
    payrollProvider
    wageType
  }
`;
